// import React from 'react';
//  import Restaurant from './restaurant/Restaurant'
 
// const App = ()=> {
//   return (
//     <>
//       <Restaurant />
//     </>
//   );
// }

// export default App;
// todo list

// import React from 'react';
// import Todo from './Todo/todo';

// const App = () => {
//   return (
//     <>
//     <Todo />
//     </>
//   )
// }

// export default App
import React from 'react';
import Todocopy from './todo_copy/todocopy';

const App = () => {
  return (
    <>
    <Todocopy />
    </>
  )
}

export default App